import React, { useState } from 'react';
import styled from 'styled-components';
import R from './glowlogo.png';
import gh from './icons/github.png';
import li from './icons/linkedin.png';
import lc from './icons/leetcode.png';
import ig from './icons/insta.png';
import md from './icons/medium.png';
import fb from './icons/facebook.png';


const MenuContainer = styled.div`
	position: relative;
	width: 280px;
	height: 280px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Toggle = styled.div`
	position: absolute;
	height: 60px;
	width: 60px;
	background: radial-gradient(circle at 40% 60%, rgb(0, 0, 0) 40%, rgb(64, 64, 64) 90.2%);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2rem;
	cursor: pointer;
	transition: 1.25s;
	box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15), 0 2px 35px #00fffc;
	animation: ${({ $blinking }) => ($blinking ? 'blink 2s infinite' : 'none')};
	z-index: 2;
`;

const MenuItem = styled.li`
	position: absolute;
	left: 0;
	list-style: none;
	padding: 10px;
	transition: 0.5s;
	transform: rotate(calc(360deg / 6 * var(--i)));
	transform-origin: 140px;
	scale: 0;
	transition-delay: calc(0.05s * var(--i));
`;

const StyledButton = styled.button`
	position: relative;
	display: flex;
	width: 60px;
	height: 60px;
	background-color: #FFF;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	border: 0;
	font-size: 2rem;
	color: var(--clr);
	transition: 0.5s, box-shadow 0.4s ease-out;

	&:hover {
		font-size: 2.25rem;
		box-shadow: 0 0 10px var(--clr);
	}
`;

// React component
const Connect = () => {
	const [isBlinking, setIsBlinking] = useState(false);
	const toggleBlink = () => {
		setIsBlinking(!isBlinking);
	};

	const renderButtons = () => {
		const buttonData = [
			{ icon: gh, link: 'https://github.com/RaviKiran25052', color: '#6b6b6b' },
			{ icon: li, link: 'http://linkedin.com/in/ravikiran25052', color: '#0a66c2' },
			{ icon: lc, link: 'https://leetcode.com/ravikiran25052/', color: '#e7a41f' },
			{ icon: ig, link: 'https://www.instagram.com/ravikiran_25052/', color: '#c32aa3' },
			{ icon: md, link: 'https://medium.com/@ravivarma25052', color: '#6b6b6b' },
			{ icon: fb, link: 'https://www.facebook.com/profile.php?id=100081346685070', color: '#1877f2' },
		];

		return buttonData.map((item, index) => (
			<MenuItem key={index} style={{ '--i': index, '--clr': item.color }}>
				<a href={item.link} target="_blank" rel="noopener noreferrer">
					<StyledButton>
						<img src={item.icon} width={35} alt={fb.split('/').pop().split('.')[0]}/>
					</StyledButton>
				</a>
			</MenuItem>
		));
	};
	
	return (
		<MenuContainer>
			<Toggle className="toggle" onClick={toggleBlink} $blinking={`${!isBlinking}`}>
			<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="64" height="64" viewBox="-8 -8 80 80">
				<image className="bubbly-button" width="64" height="64" href={R} />
			</svg>
			</Toggle>
			<ul className={`menu ${isBlinking ? 'active' : ''}`}>
				{renderButtons()}
			</ul>
		</MenuContainer>
	);
};

export default Connect;
